import { useContext } from 'react';
import { PaymentFrequency, tabType, variant1, variant2, variant3, variant4, variant5, } from '../constants';
import SpecialOffersContext from '../SpecialOffersContext';
function useSpecialOffersConfiguration() {
    let availablePaymentTabs = [];
    let fallbackPaymentFrequency = PaymentFrequency.weekly;
    let fallbackPaymentTerm = { lease: 0, finance: 0 };
    const { variant } = useContext(SpecialOffersContext);
    switch (variant) {
        case variant1:
            fallbackPaymentFrequency = PaymentFrequency.weekly;
            fallbackPaymentTerm = { lease: 60, finance: 84 };
            availablePaymentTabs = [tabType.lease, tabType.finance, tabType.rebate];
            break;
        case variant2:
            fallbackPaymentFrequency = PaymentFrequency.monthly;
            fallbackPaymentTerm = { lease: 48, finance: 84 };
            availablePaymentTabs = [tabType.lease, tabType.finance, tabType.rebate];
            break;
        case variant3:
            availablePaymentTabs = [tabType.rebate, tabType.finance];
            break;
        case variant4:
        case variant5:
            availablePaymentTabs = [tabType.rebate];
            break;
        default:
            break;
    }
    return { validPaymentTabs: availablePaymentTabs, fallbackPaymentFrequency, fallbackPaymentTerm };
}
export default useSpecialOffersConfiguration;
